import { createBehavior } from '@area17/a17-behaviors';

import navStore from '../stores/nav';

const SCROLL_POINT = 60;

const nav = createBehavior(
  'nav',
  {
    handleWindowScroll(evt) {
      if (window.scrollY > SCROLL_POINT) {
        if (!this.scrolled) {
          this.scrolled = true;
          this.$node.dispatchEvent(
            new CustomEvent('nav:scrolled', {
              bubbles: true,
              detail: {
                scrolled: this.scrolled,
              },
            })
          );
          this.render();
        }
      } else if (this.scrolled) {
        this.scrolled = false;
        this.$node.dispatchEvent(
          new CustomEvent('nav:scrolled', {
            bubbles: true,
            detail: {
              scrolled: this.scrolled,
            },
          })
        );
        this.render();
      }
    },
    handleToggleBtnClick() {
      const { open } = navStore.getState();

      if (!open) {
        this.openMenu();
      }
    },
    handleMenuOpenChange() {
      this.$openBtn.removeEventListener('click', this.handleToggleBtnClick);
      this.$node.classList.add('nav:is-menu-animating');
      if (this.disableTimeout) {
        clearTimeout(this.disableTimeout);
      }
      this.disableTimeout = setTimeout(() => {
        this.$openBtn.addEventListener('click', this.handleToggleBtnClick);
        this.$node.classList.remove('nav:is-menu-animating');
      }, 900);
    },
    openMenu() {
      navStore.setState({ open: true });
    },
    closeMenu() {
      navStore.setState({ open: false });
    },
    render() {
      this.$node.classList.toggle('nav:is-open', this.open);
      this.$node.classList.toggle('nav:is-scrolled', this.scrolled);
    },
  },
  {
    init() {
      this.disableTimeout = null;
      this.isMenuOpen = false;
      this.$openBtn = this.getChild('open-btn');

      this.$list = this.getChild('list');
      this.scrolled = false;
      this.open = false;

      this.$openBtn.addEventListener('click', this.handleToggleBtnClick);

      this.unsubscribe = navStore.subscribe((state) => {
        if (this.open === state.open) {
          return;
        }
        this.open = state.open;
        this.handleMenuOpenChange();
        this.render();
      });

      window.addEventListener('scroll', this.handleWindowScroll);

      setTimeout(() => {
        this.handleWindowScroll();
      }, 0);
    },
    destroy() {
      this.$openBtn.removeEventListener('click', this.handleToggleBtnClick);
      this.unsubscribe();
      this.scrolled = false;
      window.removeEventListener('scroll', this.handleWindowScroll);
    },
  }
);

export default nav;
